module.exports = __webpack_public_path__ + "img/enfardadores-02.85ca52c9.jpg";